import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import { AuthContext } from '../../contexts/AuthContext';

/**
 * ProtectedRoute - Redirects to /access-denied if user lacks the required permission.
 *
 * Usage:
 *   <Route path="/users" element={
 *     <ProtectedRoute permission="user.manage">
 *       <Users />
 *     </ProtectedRoute>
 *   } />
 */
const ProtectedRoute = ({ permission, children }) => {
  const { hasPermission, user, loading } = useContext(AuthContext);

  if (loading || !user) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '50vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!hasPermission(permission)) {
    return <Navigate to="/access-denied" replace />;
  }

  return children;
};

export default ProtectedRoute;
